import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
<p>
  Randonneurs.ch v1.0
</p>`,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/footer/footer.component.ts